import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';

import gms from '../store/gms';

Vue.component('booking-component', {
    props: {
        countries: {
            type: Array,
            default: () => [],
        },
        languages: {
            type: Array,
            default: () => [],
        },
        locale: {
            type: String,
        },
        visitState: {
            required: false,
        },
        initialMemberProfile: {
            required: false,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            gms,
            invitesSent: false,
        };
    },

    computed: {
        ...mapState('reservation', {
            section: (state) => state.section,
            participants: (state) => state.participants,
            month: (state) => state.month,
            date: (state) => state.date,
            activeRound: (state) => state.activeRound,
            confirmed: (state) => state.confirmed,
            booker: (state) => state.booker,
        }),
        ...mapState('member', {
            memberProfile: (state) => state.profile,
        }),
    },

    async created() {
        // Current state management is as follows:
        // Every hard page refresh checks if there is an existing reservation state
        // in the session. If so, we tell the GMS to delete this state.
        if (this.visitState && this.visitState.visitId) {
            await this.$api.gms.reservation.removeVisitClaim(this.visitState.visitId)
            .catch((error) => {
                console.log(error);
            });
        }

        if (this.initialMemberProfile) {
            this.setMemberProfile(this.initialMemberProfile);
        }
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        // Prevent user from leaving without prompt.
        // Prevent user from leaving without prompt.
        window.onbeforeunload = function() {
            return 'Are you sure you wish to leave the reservation page? All your information will be lost.';
        };
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        ...mapMutations('reservation', [
            'setSection',
            'setConfirmed',
        ]),

        ...mapMutations('member', [
            'setMemberProfile',
        ]),

        reset() {
            window.onbeforeunload = null;
            window.location.reload();
        },

        /**
         * Handles a change booking action. Shows the modal and bind the
         * reset function to the confirm button.
         *
         * @returns {Void}
         */
        onChangeBookingClick() {
            this.$modals.$emit('show-modal:reset-booking', this.reset.bind(this));
        },

        /**
         * Send invite mails to the players of which an e-mail address is known.
         *
         * @return {Void}
         */
        sendInvites() {
            // Build params from flight information.
            const flights = this.prepareFlightsForInviteCall(this.gms.flights);

            // Just set invites sent to true if there are no e-mail addresses at all.
            if (!flights.length) {
                this.invitesSent = true;
                // window.raiseGtmPageview('Step 11 - Thank You');
                return;
            }

            // Make the invites call if there's anything left to send.
            this.$api.gms.reservation.addInvites(this.gms.visitId, {
                flights,
            })
            .then((response) => {
                this.invitesSent = true;
                window.onbeforeunload = null;
                // window.raiseGtmPageview('Step 11 - Thank You');
            })
            .catch((error) => {
                // Remove erroneous e-mail address if there is one in use and try again.
                if (error.result.errors.email_address_in_use) {
                    const players = this.getAllPlayers(this.gms.flights);
                    for (let index = 0; index < players.length; index++) {
                        const player = players[index];
                        if (player.email === error.result.errors.email_address_in_use) {
                            player.email = '';
                        }
                    }

                    this.sendInvites();
                }
            });
        },

        prepareFlightsForInviteCall() {
            const result = [];

            for (let i = 0; i < this.gms.flights.length; i++) {
                // Create flight object.
                const flight = {
                    flightId: this.gms.flights[i].id,
                    memberData: [],
                };

                // Add filled out e-mail addresses.
                for (let j = 0; j < this.gms.flights[i].players.length; j++) {
                    if (this.gms.flights[i].players[j].email) {
                        flight.memberData.push({
                            memberIndex: this.gms.flights[i].players[j].index,
                            email: this.gms.flights[i].players[j].email,
                        });
                    }
                }

                // Add to params flights if any e-mail address in it.
                if (flight.memberData.length) {
                    result.push(flight);
                }
            }

            return result;
        },

        /**
         * Handle clicking send on the thank-you page.
         *
         * @return {Void}
         */
        onAddInvitesClick() {
            this.sendInvites();
        },

        /**
         * Handle clicking back to website on the thank-you page.
         *
         * @return {Void}
         */
        onBackToWebsiteClick(event) {
            window.onbeforeunload = null;
            const element = event.currentTarget;

            window.location = element.href;
        },

        getAllPlayers(flights) {
            // Flatten all the players and find the main booker.
            const players = _.flatMap(flights, (flight) => {
                const result = _.map(flight.players, (player) => {
                    player.flightId = flight.id; // eslint-disable-line no-param-reassign
                    return player;
                });
                return result;
            });

            return players;
        },
    },

    beforeDestroy() {
        window.onbeforeunload = null;
    },
});
